produto.component('produto.produtoComponent', {
    templateUrl: 'produto/produto.html',
    controller: 'produto.produtoController',
    controllerAs: '$ctrl'
});

produto.controller('produto.produtoController', ['$rootScope', '$scope', 'coreLanguage', '$state', 'coreFb', '$filter', function($rootScope, $scope, $text, $state, $fb, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    const _checkAcessoProduto=(idProduto, idAreaMembros)=>{

        $fb.db.get(`cad_areaMembros/${idAreaMembros}`).then(areaMembros=>{

            const guia = $state.params.idGuia ? areaMembros.data[$state.params.idGuia] : areaMembros.data['tab-0'];
            const produtoData = guia.produtos.find(produto=>produto.id === idProduto);

            ///Checa o produto individualmente
            if(produtoData.crossSellLink){
                $fb.functions.invoke('fatura_hasProduto', {idProduto:idProduto}).then((hasProduto)=>{
                    if(hasProduto === true){//tem o produto
                        _getProduto(idProduto);
    
                    }else{
                        $state.go('cliente.inicio');
                        window.location.href = produtoData.crossSellLink;
                    }
                });
            }else{

                let idProdutos = []
                Object.keys(guia.produtosAcesso).forEach(key=>{ 
                    if(guia.produtosAcesso[key]){ idProdutos.push(key); }
                });

                $fb.functions.invoke('fatura_hasProdutos', {idProdutos: idProdutos}).then(res=>{
                    if(!res){ 
                        $state.params.showGlobalLoading = false;

                        if(guia.linkCompra){ 
                            $state.go('cliente.inicio');
                            window.location.href = guia.linkCompra; 
                        }else{
                            $state.go('cliente.erroPermissao');
                        };

                    }else{
                        _getProduto(idProduto);
                    }
                    
                }).catch(e=>{
                    $state.go('cliente.erroPermissao');
                    $state.params.showGlobalLoading = false;
                });
            }            
        });
    };

    const _getProduto=(idProduto)=>{
        const produtoPath = `cad_produtos/${idProduto}`;

        $fb.db.get(produtoPath).then(doc=>{
            $ctrl.produto = {
                ...doc.data,
                id:doc.id
            };

            return $fb.db.list(`${produtoPath}/sessoes`, [{orderBy:['ordem']}]);

        }).then((sessoes)=>{
            $ctrl.produtoSessoes = $filter('orderBy')(sessoes, 'data.ordem');

            return $fb.db.list(`${produtoPath}/modulos`, [{orderBy:['ordem']}]);

        }).then((modulos)=>{
            $ctrl.modulos = $filter('orderBy')(modulos, 'data.ordem');
            
        }).finally(()=>{
            $state.params.showGlobalLoading = false;
        });

    };

    $ctrl.viewModulo=(modulo)=>{
        if(modulo.data.tipoModulo === 'link'){
            window.open(modulo.data.linkUrl, modulo.data.target);
        }else{
            $state.go('cliente.produtoModulo', {
                idProduto: $ctrl.produto.id,
                idModulo: modulo.id,
                idGuia: $state.params.idGuia || null
            });
        }
    };

    $ctrl.$onInit = () => {
        let idAreaMembros = $fb.auth.getIdToken().claims.idAreaMembros;

        _checkAcessoProduto($state.params.idProduto, idAreaMembros);
        $scope.isDesktop = $rootScope.isDesktop;
    };
    
}]);